import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// فقط صفحات نهایی
import Home from "./pages/home";
import Gallery from "./pages/gallery";
import ModelDetail from "./pages/gallery/ModelDetail";
import Contact from "./pages/contact";
import Terms from "./pages/legal/Terms";
import Privacy from "./pages/legal/Privacy";
import WaitlistConfirmation from "./pages/WaitlistConfirmation";

import "./assets/css/eventflow.css";
import "./assets/css/nsm.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/gallery/:slug" element={<ModelDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/waitlist-confirmation" element={<WaitlistConfirmation />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
